// extracted by mini-css-extract-plugin
export default {"wrapper":"Rule_wrapper__q5N-K"};